import React, { Fragment, useEffect, useState } from "react";
import { Link, graphql } from "gatsby";
import styled from "styled-components";

import Bio from "../components/bio";
import Layout from "../components/layout";
import SEO from "../components/seo";
import TagExplorer from "../components/TagExplorer";
import moment from "moment";
import "moment/locale/ko";

const PostHeader = styled.section`
  width: 100%;
  height: 380px;
  padding: 75px;
  display: flex;
  justify-content: center;
  background-image: url("/Front.png");
  background-position: 0 5vw;
  background-size: cover;
  @media (max-width: 768px) {
    height: 200px;
    background-size: 100% 200px;
    background-position: 0 250px;
  }
  & > p {
    margin-top: 220px;
  }
  h1,
  h2 {
    margin: 0;
    padding: 0;
    text-align: right;
    color: white;
  }
  h1 {
    font-size: 45px;
    font-weight: 900;
    text-shadow: 0 0 3px blueviolet;
    @media (max-width: 768px) {
      font-size: 24px;
      background-position: 10vw 20vw;
    }
  }
`;

const TagWrapper = styled.ul`
  list-style-type: none;
  white-space: pre-wrap;
`;

const Tag = styled.li`
  display: inline-block;
  margin-right: 12px;
  margin-bottom: 0;
  height: 25px;
  padding: 4px;
  line-height: 25px;
  font-size: 14px;
  border-radius: 14px;
`;

const BlogIndex = ({ data, location }) => {
  const siteTitle = data.site.siteMetadata?.title || `Title`;
  const posts = data.allMarkdownRemark.nodes;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (posts.length === 0) {
    return (
      <Layout location={location} title={siteTitle}>
        <SEO title="MOIN 모인 기술 블로그" />
        <Bio />
        <p>SOMETHING WRONG</p>
      </Layout>
    );
  }

  return (
    <Fragment>
      <PostHeader />
      <Layout location={location} title={siteTitle}>
        <SEO title="MOIN 모인 기술 블로그" />
        {/* <Bio /> */}
        <TagExplorer group={data.allMarkdownRemark.group} />
        <ol style={{ listStyle: `none` }}>
          {posts.map((post) => {
            const title = post.frontmatter.title || post.fields.slug;

            return (
              <li key={post.fields.slug}>
                <Link to={post.fields.slug} itemProp="url">
                  <article
                    className="post-list-item"
                    itemScope
                    itemType="http://schema.org/Article"
                  >
                    <header>
                      <h2>
                        <span itemProp="headline">{title}</span>
                      </h2>
                      <small>
                        {moment(post.frontmatter.date)
                          .locale("ko")
                          .format("LL")}
                      </small>
                    </header>
                    <section>
                      <TagWrapper>
                        {post.frontmatter.tags
                          ? post.frontmatter.tags.map((tag) => {
                              return <Tag>#{tag}</Tag>;
                            })
                          : null}
                      </TagWrapper>
                      <p
                        dangerouslySetInnerHTML={{
                          __html: post.frontmatter.description || post.excerpt,
                        }}
                        itemProp="description"
                      />
                    </section>
                  </article>
                </Link>
              </li>
            );
          })}
        </ol>
      </Layout>
    </Fragment>
  );
};

export default BlogIndex;

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark(sort: { fields: [frontmatter___date], order: DESC }) {
      group(field: frontmatter___tags) {
        tag: fieldValue
        totalCount
      }
      nodes {
        excerpt
        fields {
          slug
        }
        frontmatter {
          date(formatString: "MMMM DD, YYYY")
          title
          description
          tags
        }
      }
    }
  }
`;
